/* eslint-disable @typescript-eslint/ban-ts-comment */
import { apiRefresh } from 'api/auth/index';
import { createRefresh } from 'react-auth-kit';
import { ONE_DAY_IN_SECONDS, SEVEN_DAYS_IN_SECONDS } from 'utils/constants';

export const refreshApi = createRefresh({
  interval: ONE_DAY_IN_SECONDS,
  //@ts-ignore
  refreshApiCallback: async ({ refreshToken }) => {
    try {
      const response = await apiRefresh({ refreshToken });
      return {
        isSuccess: response.isCompleted,
        newAuthToken: response.accessToken,
        newAuthTokenExpireIn: response.expiresIn,
        newRefreshToken: response.refreshToken || refreshToken,
        newRefreshTokenExpiresIn: SEVEN_DAYS_IN_SECONDS,
      };
    } catch (error) {
      return {
        isSuccess: false,
      };
    }
  },
});
